function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useContext } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { spacing4, spacing8 } from "@churchofjesuschrist/eden-style-constants";
import { InternalUseOnlyHint } from "./Hint";
import { InternalUseOnlyLabel } from "./Label";
import { ValidityStateContext } from "./validityState";
import { InternalUseOnlyInputGroup } from "./InputGroup";
import { InternalUseOnlyFileInput } from "./FileInput";
import { InternalUseOnlyInput } from "./Input";
import { InternalUseOnlyTextArea } from "./TextArea";
import { InternalUseOnlySelect } from "./Select";
import { InternalUseOnlyRangeInput } from "./RangeInput";
import { InternalUseOnlyMultiRangeField } from "./MultiRangeField";
const Container = styled.div.withConfig({
  componentId: "sc-xne1im-0"
})(["& > ", "{", ";}& > ", "{display:block;margin-block-start:", ";margin-inline-start:", ";}"], InternalUseOnlyLabel, _ref => {
  let {
    layout
  } = _ref;
  return ` 
      display: ${layout === "inline" ? "inline-flex" : "flex"};
      flex-wrap: wrap;
      column-gap: ${spacing8};
      row-gap: ${spacing4};
      align-items: center;
      padding-inline-start: ${layout === "inline" ? null : spacing8};

      & > ${InternalUseOnlyInput},
      & > ${InternalUseOnlyTextArea},
      & > ${InternalUseOnlySelect}, 
      & > ${InternalUseOnlyInputGroup},
      & > ${InternalUseOnlyFileInput},
      & > ${InternalUseOnlyRangeInput},
      & > ${InternalUseOnlyMultiRangeField} {
        ${layout === "inline" ? "" : `flex-basis: calc(100% + ${spacing8});
               margin-inline-start: -${spacing8};
               
               &[readonly]{
                margin-block-start: -${spacing4};
               }
               `};
      }
    `;
}, InternalUseOnlyHint, spacing4, spacing8);
/**
 * The FormField is used to group one control with its helper components such as Label and Hint.
 */

const FormField = _ref2 => {
  let {
    children,
    layout = "block",
    validityState,
    ...props
  } = _ref2;
  const validityStateContext = useContext(ValidityStateContext);
  return /*#__PURE__*/React.createElement(Container, _extends({
    layout: layout
  }, props), /*#__PURE__*/React.createElement(ValidityStateContext.Provider, {
    value: validityState ? validityState : validityStateContext
  }, children));
};

FormField.propTypes = {
  /** The current validity state of the FormField */
  validityState: PropTypes.oneOf(["error", "warning", "success", "unknown"]),

  /** Content to render inside the FormField Component */
  children: PropTypes.node.isRequired,

  /** Displays label inline with input */
  layout: PropTypes.oneOf(["inline", "block"])
};
export default FormField;